"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const RewardDefinition_1 = require("./RewardDefinition");
const zod_1 = require("zod");
const createQuestConfigValidator = new validation_1.Validator("SourceTemplateExists", async (reward, context) => {
    const sourceTemplateId = reward?.config?.sourceTemplateId;
    if (!sourceTemplateId) {
        return [
            {
                errorCode: "REQUIRED",
                path: ["sourceTemplateId"],
                message: "Source Template is required.",
            },
        ];
    }
    const questExists = await context.checkQuestExists(sourceTemplateId);
    if (!questExists) {
        return [
            {
                errorCode: "INVALID",
                path: ["sourceTemplateId"],
                message: "Source Template not available.",
            },
        ];
    }
    return [];
});
exports.default = new RewardDefinition_1.RewardDefinition("CREATE_QUEST", zod_1.z.object({ sourceTemplateId: zod_1.z.string().uuid() }), zod_1.z.object({
    createdQuestId: zod_1.z.string().optional(),
    createdQuestPrototypeId: zod_1.z.string().optional(),
}), createQuestConfigValidator, validation_1.NO_OP_VALIDATOR);
//# sourceMappingURL=CREATE_QUEST.js.map